$(function () {
    var form = $('.js-user-form')
        .removeData('validator')
        .removeData('unobtrusiveValidation');

    $.validator.unobtrusive.parse(form);

    // Firefox dont support trim for email input
    $(document).on('change', '#Email', function (e) {
        this.value = this.value.trim();
    });

    // Remove server validation messages when change some input in form
    $(document).on('keyup', '.js-user-form input', function (e) {
        var $errors = $(".js-user-form .js-user-form-errors");
        $errors.removeClass('o-flash-message--visible');
    });

    // Log in
    $(document).on('click', '.js-user-login', function (e) {
        e.preventDefault();
        var $errors = $(".js-user-form .js-user-form-errors");
        $errors.removeClass('o-flash-message--visible');
        $('.js-send-confirmed-email').remove();

        if (!validate()) return;

        var data = $(".js-user-form").serialize();

        $.ajax({
            method: 'POST',
            url: '/Users/LoginPost',
            data: data,
            success: function (response) {
                closePopupAndRedirect(response);
            },
            error: function (response) {
                $('#user-popup-login-password').val('');
                if (response.responseJSON) {
                    $errors.text(response.responseJSON.error);
                    $errors.addClass('o-flash-message--visible');

                    if (response.responseJSON.code === 'not-approved' && $('.js-send-confirmed-email').length === 0) {
                        let linkElement = $('<a href=\'#\'> </a>').text('Poslat odkaz znovu').addClass('c-user-popup__misc-link js-send-confirmed-email');
                        $errors.after(linkElement);
                    }
                }
            }
        });
    });

    // Send confirmation email for not approved users
    $(document).on('click', '.js-send-confirmed-email', function (e) {
        let email = $('#user-popup-login-email').val();
        let token = $('[name=__RequestVerificationToken]').val();
        let $errors = $(".js-user-form .js-user-form-errors");

        $.ajax({
            method: 'PUT',
            url: '/Users/SendConfirmationEmail',
            headers: {
                RequestVerificationToken: token
            },
            data: { email: email },
            success: function (response) {
                $('.js-send-confirmed-email').remove();
                closePopupAndRedirect(response);
            },
            error: function (response) {
                let errorText = 'Ověřovací email nebyl znovu odeslán. Kontaktujte, prosím podporu.';

                $('.js-send-confirmed-email').remove();

                if (response.responseText && response.status === 429) {
                    errorText = response.responseText;
                }

                $errors.text(errorText);
            }
        });
    });

    // Open lost password
    $(document).on('click', '.js-open-user-lost-password', function (e) {
        $.ajax({
            url: `/Users/ResetPasswordByEmail?returnUrl=${getLoginReturnUrl()}`,
            success: function (html) {
                $('.js-user-popup').html(html);
                $('.js-user-popup-login').removeClass('c-user-popup__container--active');
                $('.js-user-popup-lost-password').addClass('c-user-popup__container--active');
            }
        });
    });

    // Submit lost password
    $(document).on('click', '#js-user-lost-password', function (e) {
        e.preventDefault();
        if (!validate(e)) return;

        var data = $(".js-user-form").serialize();

        $.ajax({
            method: 'POST',
            url: '/Users/ResetPasswordByEmail',
            data: data,
            success: function () {
                $(".js-user-form").html('<div class="o-flash-message o-flash-message--success o-flash-message--visible">Odesláno</div>');
            }
        });
    });

    // Open registration
    $(document).on('click', '.js-open-user-registration', function (e) {
        $.ajax({
            url: `/Users/Registration?returnUrl=${getLoginReturnUrl()}`,
            success: function (html) {
                $('.js-user-popup').html(html);
                $('.js-user-popup-login').removeClass('c-user-popup__container--active');
                $('.js-user-popup-registration').addClass('c-user-popup__container--active');
            }
        });
    });

    // Submit registration
    $(document).on('click', '#js-user-registration', function (e) {
        e.preventDefault();
        var $errorMessage = $('.js-user-form .js-error-message');
        $errorMessage.removeClass('o-flash-message--visible');
        $errorMessage.empty();

        var name = $("#Name").val().trim();
        $("#Name").val(name);

        if (!validate()) return;

        var data = $(".js-user-form").serialize();

        $.ajax({
            method: 'POST',
            url: '/Users/Registration',
            data: data,
            success: function (response) {
                $(".js-user-form").html('<div class="o-flash-message o-flash-message--success o-flash-message--visible">Vaše registrace proběhla úspěšně. Před prvním přihlášením prosím potvrďte svoji e-mailovou adresu pomocí odkazu, který jsme na ni odeslali.</div>');
            },
            error: function (response) {
                if (response.responseText) {
                    $errorMessage.html(response.responseText);
                    $errorMessage.addClass('o-flash-message--visible');
                }
            }
        });
    });

    // Submit social registration
    $(document).on('click', '#js-user-social-registration', function (e) {
        e.preventDefault();
        var $errorMessage = $('.js-user-form .js-error-message');
        $errorMessage.removeClass('o-flash-message--visible');
        $errorMessage.empty();

        if (!validate()) return;

        var data = $(".js-user-form").serialize();

        $.ajax({
            method: 'POST',
            url: '/Users/SocialRegistration',
            data: data,
            success: function (response) {
                closePopupAndRedirect(response);
            },
            error: function (response) {
                if (response.responseText) {
                    $errorMessage.html(response.responseText);
                    $errorMessage.addClass('o-flash-message--visible');
                }
            }
        });
    });

    // Open company registration
    $(document).on('click', '.js-user-open-company-registration', function (e) {
        $.ajax({
            url: `/Users/CompanyRegistration?returnUrl=${getLoginReturnUrl()}`,
            success: function (html) {
                $('.js-user-popup').html(html);
                $('.js-user-popup-registration').addClass('c-user-popup__container--active');
            }
        });
    });

    // Open company social registration
    $(document).on('click', '.js-user-open-company-social-registration', function (e) {
        $.ajax({
            url: `/Users/CompanySocialRegistration?returnUrl=${getLoginReturnUrl()}`,
            success: function (html) {
                $('.js-user-popup').html(html);
                $('.js-user-popup-social-registration').addClass('c-user-popup__container--active');
            }
        });
    });

    // Close user popup
    $(document).on('click', '.js-close-user-popup', function (e) {
        $('.c-user-popup__container--active').removeClass('c-user-popup__container--active');
        $('.js-user-popup').removeClass('c-user-popup--visible');
    });

    // Show password
    $('.js-show-password').on('mousedown touchstart', function (e) {
        $('#' + $(this).attr('data-for')).attr('type', 'text');
    }).bind('mouseup mouseleave touchend', function () {
        $('#' + $(this).attr('data-for')).attr('type', 'password');
        $('#' + $(this).attr('data-for')).focus();
    });
});

function validate(e) {
    var form = $('.js-user-form')
        .removeData('validator')
        .removeData('unobtrusiveValidation');

    $.validator.unobtrusive.parse(form);
    return $(form).valid();
}

function closePopupAndRedirect(response) {
    $('.js-user-popup').removeClass('c-user-popup--visible');

    var originalUrl = new URL(window.location);
    originalUrl.hash = '';

    if (redirectToUrl) {
        response.redirect = redirectToUrl;
        redirectToUrl = undefined;
    }

    // Redirect can contain full URL or only path
    var redirectUrl = response.redirect[0] == '/'
        ? new URL(originalUrl.origin + response.redirect)
        : new URL(response.redirect);

    redirectUrl.hash = '';

    var isSameUrl = originalUrl.toString() === redirectUrl.toString();

    redirectUrl.hash = window.location.hash;

    window.location.href = redirectUrl.toString();

    if (isSameUrl && redirectUrl.hash) {
        window.location.reload();
    }
}

function socialLogin(provider, token) {
    $.ajax({
        type: 'GET',
        url: '/Users/SocialLogin?provider=' + provider + '&token=' + token,
        success: function (response) {
            closePopupAndRedirect(response);
        },
        error: function (err) {
            console.log(err);
        }
    });
}